import { render, staticRenderFns } from "./AddQuestions.vue?vue&type=template&id=cb698afc&scoped=true&"
import script from "./AddQuestions.vue?vue&type=script&lang=js&"
export * from "./AddQuestions.vue?vue&type=script&lang=js&"
import style0 from "./AddQuestions.vue?vue&type=style&index=0&id=cb698afc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb698afc",
  null
  
)

export default component.exports